import type {
  FeatureToggle,
  FeatureToggleIdentifier,
} from '@schema/featureToggle'

type FeatureToggleLike = Pick<FeatureToggle, 'identifier' | 'enabled'>

/**
 * Returns whether the given identifier is enabled in the toggles list.
 */
export const isFeatureEnabled = (
  toggles: FeatureToggleLike[] | undefined,
  identifier: FeatureToggleIdentifier,
): boolean => {
  return (
    toggles?.some((ft) => ft.identifier === identifier && ft.enabled) ?? false
  )
}

/**
 * Returns whether a tab should be shown based on content and feature toggle.
 */
export const isTabAvailable = (
  toggles: FeatureToggleLike[] | undefined,
  identifier: FeatureToggleIdentifier,
  hasContent = true,
): boolean => {
  return hasContent && isFeatureEnabled(toggles, identifier)
}
